import { render, staticRenderFns } from "./MaintenanceItemTypeList.vue?vue&type=template&id=3204b1b7"
import script from "./MaintenanceItemTypeList.vue?vue&type=script&lang=ts"
export * from "./MaintenanceItemTypeList.vue?vue&type=script&lang=ts"
import style0 from "./MaintenanceItemTypeList.vue?vue&type=style&index=0&id=3204b1b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports